export const API_URL = process.env.REACT_APP_API_URL || '';
export const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN || '';
export const IS_MULTILINGUAL = process.env.REACT_APP_IS_MULTILINGUAL || 'false';
export const EMAIL_PREFIX = process.env.REACT_APP_EMAIL_PREFIX || '';
export const APP_VERSION = process.env.REACT_APP_VERSION || '';
